var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item-box",on:{"click":_vm.openService}},[_c('h1',[_vm._v(" "+_vm._s(_vm.service.name)+" ")]),_vm._v(" "),(_vm.service.actionable == true)?_c('button',{staticClass:"action-button",on:{"click":function($event){_vm.takeAction()}}},[_vm._v("W")]):_c('h2',[_vm._v(_vm._s(_vm.service.latestData.value)+" "+_vm._s(_vm.service.unit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b4de5730","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ItemBox.vue
// module id = null
// module chunks = 